import React, { useEffect, useState, useRef } from 'react';
import { Link } from 'react-router-dom';
import { Home, BarChart3, UserCog, FileText, Bell, ChevronDown, Users, Globe, Clock, Info, ExternalLink, Check, Settings as SettingsIcon } from 'lucide-react';
import { motion } from 'framer-motion';
export function SettingsPage() {
  const [isUserMenuOpen, setIsUserMenuOpen] = useState(false);
  const userMenuRef = useRef<HTMLDivElement>(null);
  // Notification Settings State
  const [notificationScope, setNotificationScope] = useState('account');
  const [gradingWeb, setGradingWeb] = useState(true);
  const [gradingEmail, setGradingEmail] = useState(true);
  const [gradingFrequency, setGradingFrequency] = useState('daily');
  const [updatesWeb, setUpdatesWeb] = useState(true);
  const [updatesEmail, setUpdatesEmail] = useState(false);
  const [updatesFrequency, setUpdatesFrequency] = useState('daily');
  const [activityWeb, setActivityWeb] = useState(true);
  const [activityEmail, setActivityEmail] = useState(true);
  const [activityFrequency, setActivityFrequency] = useState('daily');
  const [newQuestionWeb, setNewQuestionWeb] = useState(false);
  const [newQuestionEmail, setNewQuestionEmail] = useState(false);
  const [newQuestionFrequency, setNewQuestionFrequency] = useState('daily');
  const [newDiscussionWeb, setNewDiscussionWeb] = useState(false);
  const [newDiscussionEmail, setNewDiscussionEmail] = useState(false);
  const [newDiscussionFrequency, setNewDiscussionFrequency] = useState('daily');
  // Site Preferences State
  const [siteLanguage, setSiteLanguage] = useState('English');
  const [timezone, setTimezone] = useState('UTC-5');
  // Linked Accounts State
  const [linkedAccounts, setLinkedAccounts] = useState({
    apple: false,
    facebook: false,
    google: true,
    microsoft: false
  });
  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (userMenuRef.current && !userMenuRef.current.contains(event.target as Node)) {
        setIsUserMenuOpen(false);
      }
    };
    if (isUserMenuOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    }
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isUserMenuOpen]);
  return <div className="flex-1 bg-gray-50 min-h-screen" data-id="element-1846">
      {/* Top Navigation */}
      <div className="bg-white border-b border-gray-200" data-id="element-1847">
        <div className="max-w-[1440px] mx-auto px-8" data-id="element-1848">
          <div className="flex items-center h-16" data-id="element-1849">
            {/* Logo */}
            <div className="text-[#DB3725] font-bold text-xl" data-id="element-1850">LOGO</div>

            {/* Navigation Links */}
            <nav className="flex items-center gap-8 ml-12" data-id="element-1851">
              <Link to="/admin" className="flex items-center gap-2 text-gray-600 hover:text-gray-900 transition-colors text-sm font-medium" data-id="element-1852">
                <Home size={18} data-id="element-1853" />
                <span data-id="element-1854">Admin Hub</span>
              </Link>
              <Link to="/analytics" className="flex items-center gap-2 text-gray-600 hover:text-gray-900 transition-colors text-sm font-medium" data-id="element-1855">
                <BarChart3 size={18} data-id="element-1856" />
                <span data-id="element-1857">Analytics</span>
              </Link>
              <Link to="/feedback" className="flex items-center gap-2 text-gray-600 hover:text-gray-900 transition-colors text-sm font-medium" data-id="element-1858">
                <FileText size={18} data-id="element-1859" />
                <span data-id="element-1860">Reports</span>
              </Link>
              <Link to="/assessment" className="flex items-center gap-2 text-gray-600 hover:text-gray-900 transition-colors text-sm font-medium" data-id="element-1861">
                <UserCog size={18} data-id="element-1862" />
                <span data-id="element-1863">Users</span>
              </Link>
            </nav>

            {/* Right Side - User Info */}
            <div className="flex items-center gap-4 ml-auto" data-id="element-1864">
              <Link to="/alerts" className="relative p-2 text-gray-600 hover:text-gray-900 transition-colors" data-id="element-1865">
                <Bell size={20} data-id="element-1866" />
                <span className="absolute top-1 right-1 w-2 h-2 bg-[#DB3725] rounded-full" data-id="element-1867"></span>
              </Link>
              <div className="relative" ref={userMenuRef} data-id="element-1868">
                <button onClick={() => setIsUserMenuOpen(!isUserMenuOpen)} className="flex items-center gap-3 hover:bg-gray-50 rounded-lg px-2 py-1 transition-colors" data-id="element-1869">
                  <div className="w-8 h-8 rounded-full bg-gray-200 flex items-center justify-center text-gray-600 text-sm font-medium" data-id="element-1870">
                    LT
                  </div>
                  <span className="text-sm font-medium text-gray-900" data-id="element-1871">
                    Linda Taylor
                  </span>
                  <ChevronDown size={16} className="text-gray-600" data-id="element-1872" />
                </button>

                {isUserMenuOpen && <div className="absolute top-full right-0 mt-2 w-56 bg-white border border-gray-200 rounded-lg shadow-lg z-50" data-id="element-1873">
                    <div className="py-2" data-id="element-1874">
                      <Link to="/profile" className="w-full flex items-center gap-3 px-4 py-2.5 text-left hover:bg-gray-50 transition-colors text-sm" data-id="element-1875">
                        <Users size={18} className="text-gray-600" data-id="element-1876" />
                        <span className="font-medium text-gray-900" data-id="element-1877">
                          Profile
                        </span>
                      </Link>
                      <button className="w-full flex items-center gap-3 px-4 py-2.5 text-left hover:bg-gray-50 transition-colors text-sm" data-id="element-1878">
                        <Home size={18} className="text-gray-600" data-id="element-1879" />
                        <span className="font-medium text-gray-900" data-id="element-1880">
                          Learner Hub
                        </span>
                      </button>
                      <Link to="/admin" className="w-full flex items-center gap-3 px-4 py-2.5 text-left hover:bg-gray-50 transition-colors text-sm" data-id="element-1881">
                        <UserCog size={18} className="text-gray-600" data-id="element-1882" />
                        <span className="font-medium text-gray-900" data-id="element-1883">
                          Admin Hub
                        </span>
                      </Link>
                      <Link to="/settings" className="w-full flex items-center gap-3 px-4 py-2.5 text-left hover:bg-gray-50 transition-colors text-sm" data-id="element-1884">
                        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="text-gray-600" data-id="element-1885">
                          <path d="M12.22 2h-.44a2 2 0 0 0-2 2v.18a2 2 0 0 1-1 1.73l-.43.25a2 2 0 0 1-2 0l-.15-.08a2 2 0 0 0-2.73.73l-.22.38a2 2 0 0 0 .73 2.73l.15.1a2 2 0 0 1 1 1.72v.51a2 2 0 0 1-1 1.74l-.15.09a2 2 0 0 0-.73 2.73l.22.38a2 2 0 0 0 2.73.73l.15-.08a2 2 0 0 1 2 0l.43.25a2 2 0 0 1 1 1.73V20a2 2 0 0 0 2 2h.44a2 2 0 0 0 2-2v-.18a2 2 0 0 1 1-1.73l.43-.25a2 2 0 0 1 2 0l.15.08a2 2 0 0 0 2.73-.73l.22-.39a2 2 0 0 0-.73-2.73l-.15-.08a2 2 0 0 1-1-1.74v-.5a2 2 0 0 1 1-1.74l.15-.09a2 2 0 0 0 .73-2.73l-.22-.38a2 2 0 0 0-2.73-.73l-.15.08a2 2 0 0 1-2 0l-.43-.25a2 2 0 0 1-1-1.73V4a2 2 0 0 0-2-2z" data-id="element-1886"></path>
                          <circle cx="12" cy="12" r="3" data-id="element-1887"></circle>
                        </svg>
                        <span className="font-medium text-gray-900" data-id="element-1888">
                          Settings
                        </span>
                      </Link>
                      <div className="border-t border-gray-200 my-2" data-id="element-1889"></div>
                      <button className="w-full flex items-center gap-3 px-4 py-2.5 text-left hover:bg-gray-50 transition-colors text-sm" data-id="element-1890">
                        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="text-gray-600" data-id="element-1891">
                          <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" data-id="element-1892"></path>
                          <polyline points="16 17 21 12 16 7" data-id="element-1893"></polyline>
                          <line x1="21" y1="12" x2="9" y2="12" data-id="element-1894"></line>
                        </svg>
                        <span className="font-medium text-gray-900" data-id="element-1895">
                          Logout
                        </span>
                      </button>
                    </div>
                  </div>}
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Main Content */}
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-8" data-id="element-1896">
        {/* Header */}
        <div className="mb-8" data-id="element-1897">
          <h1 className="text-3xl font-bold text-gray-900 mb-2" data-id="element-1898">Settings</h1>
          <p className="text-gray-600" data-id="element-1899">
            Manage your notification preferences and account settings
          </p>
        </div>

        <div className="space-y-8" data-id="element-1900">
          {/* Notifications Section */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.1
        }} className="bg-white rounded-xl shadow-sm border border-gray-200 overflow-hidden" data-id="element-1901">
            <div className="p-6 border-b border-gray-200" data-id="element-1902">
              <h2 className="text-xl font-bold text-gray-900 mb-2" data-id="element-1903">
                Notifications
              </h2>
              <div className="text-sm text-gray-600 space-y-2" data-id="element-1904">
                <p data-id="element-1905">
                  Account-level settings apply to all courses. Notifications for
                  individual courses can be changed within each course and will
                  override account-level settings.
                </p>
                <p data-id="element-1906">
                  Daily notifications are delivered at 22:00 UTC. Weekly
                  notifications are delivered at 22:00 UTC Every Sunday.
                </p>
                <p className="text-[#30718D]" data-id="element-1907">
                  Notifications for certain activities are enabled by default,{' '}
                  <a href="#" className="underline hover:text-[#265a70]" data-id="element-1908">
                    as detailed here
                  </a>
                  <ExternalLink size={12} className="inline ml-1" data-id="element-1909" />
                </p>
              </div>
            </div>

            <div className="p-6" data-id="element-1910">
              {/* Notification Scope Selector */}
              <div className="mb-6" data-id="element-1911">
                <label className="block text-sm font-semibold text-gray-700 mb-2" data-id="element-1912">
                  Select notifications for
                </label>
                <select value={notificationScope} onChange={e => setNotificationScope(e.target.value)} className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#30718D] focus:border-transparent" data-id="element-1913">
                  <option value="account" data-id="element-1914">Account</option>
                  <option value="course1" data-id="element-1915">Course 1</option>
                  <option value="course2" data-id="element-1916">Course 2</option>
                </select>
                <p className="text-xs text-gray-500 mt-1" data-id="element-1917">
                  Applies to all courses
                </p>
              </div>

              {/* Notification Settings Table */}
              <div className="space-y-6" data-id="element-1918">
                {/* Grading */}
                <div data-id="element-1919">
                  <h3 className="text-base font-bold text-gray-900 mb-3" data-id="element-1920">
                    Grading
                  </h3>
                  <div className="flex items-center justify-between py-3 border-b border-gray-100" data-id="element-1921">
                    <div className="flex-1" data-id="element-1922">
                      <span className="text-sm text-gray-700" data-id="element-1923">
                        Essay assignment grade received
                      </span>
                    </div>
                    <div className="flex items-center gap-8" data-id="element-1924">
                      <div className="flex items-center gap-2" data-id="element-1925">
                        <span className="text-xs font-medium text-gray-500 w-8" data-id="element-1926">
                          Web
                        </span>
                        <button onClick={() => setGradingWeb(!gradingWeb)} className={`relative inline-flex h-6 w-11 items-center rounded-full transition-colors ${gradingWeb ? 'bg-[#007558]' : 'bg-gray-300'}`} data-id="element-1927">
                          <span className={`inline-block h-4 w-4 transform rounded-full bg-white transition-transform ${gradingWeb ? 'translate-x-6' : 'translate-x-1'}`} data-id="element-1928" />
                        </button>
                      </div>
                      <div className="flex items-center gap-2" data-id="element-1929">
                        <span className="text-xs font-medium text-gray-500 w-8" data-id="element-1930">
                          Email
                        </span>
                        <button onClick={() => setGradingEmail(!gradingEmail)} className={`relative inline-flex h-6 w-11 items-center rounded-full transition-colors ${gradingEmail ? 'bg-[#007558]' : 'bg-gray-300'}`} data-id="element-1931">
                          <span className={`inline-block h-4 w-4 transform rounded-full bg-white transition-transform ${gradingEmail ? 'translate-x-6' : 'translate-x-1'}`} data-id="element-1932" />
                        </button>
                      </div>
                      <select value={gradingFrequency} onChange={e => setGradingFrequency(e.target.value)} className="px-3 py-1.5 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-[#30718D] focus:border-transparent" data-id="element-1933">
                        <option value="daily" data-id="element-1934">Daily</option>
                        <option value="weekly" data-id="element-1935">Weekly</option>
                        <option value="immediately" data-id="element-1936">Immediately</option>
                      </select>
                    </div>
                  </div>
                </div>

                {/* Updates */}
                <div data-id="element-1937">
                  <h3 className="text-base font-bold text-gray-900 mb-3" data-id="element-1938">
                    Updates
                  </h3>
                  <div className="flex items-center justify-between py-3 border-b border-gray-100" data-id="element-1939">
                    <div className="flex-1" data-id="element-1940">
                      <span className="text-sm text-gray-700" data-id="element-1941">
                        Course updates
                      </span>
                    </div>
                    <div className="flex items-center gap-8" data-id="element-1942">
                      <div className="flex items-center gap-2" data-id="element-1943">
                        <span className="text-xs font-medium text-gray-500 w-8" data-id="element-1944">
                          Web
                        </span>
                        <button onClick={() => setUpdatesWeb(!updatesWeb)} className={`relative inline-flex h-6 w-11 items-center rounded-full transition-colors ${updatesWeb ? 'bg-[#007558]' : 'bg-gray-300'}`} data-id="element-1945">
                          <span className={`inline-block h-4 w-4 transform rounded-full bg-white transition-transform ${updatesWeb ? 'translate-x-6' : 'translate-x-1'}`} data-id="element-1946" />
                        </button>
                      </div>
                      <div className="flex items-center gap-2" data-id="element-1947">
                        <span className="text-xs font-medium text-gray-500 w-8" data-id="element-1948">
                          Email
                        </span>
                        <button onClick={() => setUpdatesEmail(!updatesEmail)} className={`relative inline-flex h-6 w-11 items-center rounded-full transition-colors ${updatesEmail ? 'bg-[#007558]' : 'bg-gray-300'}`} data-id="element-1949">
                          <span className={`inline-block h-4 w-4 transform rounded-full bg-white transition-transform ${updatesEmail ? 'translate-x-6' : 'translate-x-1'}`} data-id="element-1950" />
                        </button>
                      </div>
                      <select value={updatesFrequency} onChange={e => setUpdatesFrequency(e.target.value)} className="px-3 py-1.5 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-[#30718D] focus:border-transparent" data-id="element-1951">
                        <option value="daily" data-id="element-1952">Daily</option>
                        <option value="weekly" data-id="element-1953">Weekly</option>
                        <option value="immediately" data-id="element-1954">Immediately</option>
                      </select>
                    </div>
                  </div>
                </div>

                {/* Discussions */}
                <div data-id="element-1955">
                  <h3 className="text-base font-bold text-gray-900 mb-3" data-id="element-1956">
                    Discussions
                  </h3>
                  <div className="space-y-3" data-id="element-1957">
                    <div className="flex items-center justify-between py-3 border-b border-gray-100" data-id="element-1958">
                      <div className="flex-1 flex items-center gap-2" data-id="element-1959">
                        <span className="text-sm text-gray-700" data-id="element-1960">
                          Activity notifications
                        </span>
                        <Info size={14} className="text-gray-400" data-id="element-1961" />
                      </div>
                      <div className="flex items-center gap-8" data-id="element-1962">
                        <div className="flex items-center gap-2" data-id="element-1963">
                          <span className="text-xs font-medium text-gray-500 w-8" data-id="element-1964">
                            Web
                          </span>
                          <button onClick={() => setActivityWeb(!activityWeb)} className={`relative inline-flex h-6 w-11 items-center rounded-full transition-colors ${activityWeb ? 'bg-[#007558]' : 'bg-gray-300'}`} data-id="element-1965">
                            <span className={`inline-block h-4 w-4 transform rounded-full bg-white transition-transform ${activityWeb ? 'translate-x-6' : 'translate-x-1'}`} data-id="element-1966" />
                          </button>
                        </div>
                        <div className="flex items-center gap-2" data-id="element-1967">
                          <span className="text-xs font-medium text-gray-500 w-8" data-id="element-1968">
                            Email
                          </span>
                          <button onClick={() => setActivityEmail(!activityEmail)} className={`relative inline-flex h-6 w-11 items-center rounded-full transition-colors ${activityEmail ? 'bg-[#007558]' : 'bg-gray-300'}`} data-id="element-1969">
                            <span className={`inline-block h-4 w-4 transform rounded-full bg-white transition-transform ${activityEmail ? 'translate-x-6' : 'translate-x-1'}`} data-id="element-1970" />
                          </button>
                        </div>
                        <select value={activityFrequency} onChange={e => setActivityFrequency(e.target.value)} className="px-3 py-1.5 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-[#30718D] focus:border-transparent" data-id="element-1971">
                          <option value="daily" data-id="element-1972">Daily</option>
                          <option value="weekly" data-id="element-1973">Weekly</option>
                          <option value="immediately" data-id="element-1974">Immediately</option>
                        </select>
                      </div>
                    </div>

                    <div className="flex items-center justify-between py-3 border-b border-gray-100" data-id="element-1975">
                      <div className="flex-1" data-id="element-1976">
                        <span className="text-sm text-gray-700" data-id="element-1977">
                          New question posts
                        </span>
                      </div>
                      <div className="flex items-center gap-8" data-id="element-1978">
                        <div className="flex items-center gap-2" data-id="element-1979">
                          <span className="text-xs font-medium text-gray-500 w-8" data-id="element-1980">
                            Web
                          </span>
                          <button onClick={() => setNewQuestionWeb(!newQuestionWeb)} className={`relative inline-flex h-6 w-11 items-center rounded-full transition-colors ${newQuestionWeb ? 'bg-[#007558]' : 'bg-gray-300'}`} data-id="element-1981">
                            <span className={`inline-block h-4 w-4 transform rounded-full bg-white transition-transform ${newQuestionWeb ? 'translate-x-6' : 'translate-x-1'}`} data-id="element-1982" />
                          </button>
                        </div>
                        <div className="flex items-center gap-2" data-id="element-1983">
                          <span className="text-xs font-medium text-gray-500 w-8" data-id="element-1984">
                            Email
                          </span>
                          <button onClick={() => setNewQuestionEmail(!newQuestionEmail)} className={`relative inline-flex h-6 w-11 items-center rounded-full transition-colors ${newQuestionEmail ? 'bg-[#007558]' : 'bg-gray-300'}`} data-id="element-1985">
                            <span className={`inline-block h-4 w-4 transform rounded-full bg-white transition-transform ${newQuestionEmail ? 'translate-x-6' : 'translate-x-1'}`} data-id="element-1986" />
                          </button>
                        </div>
                        <select value={newQuestionFrequency} onChange={e => setNewQuestionFrequency(e.target.value)} className="px-3 py-1.5 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-[#30718D] focus:border-transparent" data-id="element-1987">
                          <option value="daily" data-id="element-1988">Daily</option>
                          <option value="weekly" data-id="element-1989">Weekly</option>
                          <option value="immediately" data-id="element-1990">Immediately</option>
                        </select>
                      </div>
                    </div>

                    <div className="flex items-center justify-between py-3" data-id="element-1991">
                      <div className="flex-1" data-id="element-1992">
                        <span className="text-sm text-gray-700" data-id="element-1993">
                          New discussion posts
                        </span>
                      </div>
                      <div className="flex items-center gap-8" data-id="element-1994">
                        <div className="flex items-center gap-2" data-id="element-1995">
                          <span className="text-xs font-medium text-gray-500 w-8" data-id="element-1996">
                            Web
                          </span>
                          <button onClick={() => setNewDiscussionWeb(!newDiscussionWeb)} className={`relative inline-flex h-6 w-11 items-center rounded-full transition-colors ${newDiscussionWeb ? 'bg-[#007558]' : 'bg-gray-300'}`} data-id="element-1997">
                            <span className={`inline-block h-4 w-4 transform rounded-full bg-white transition-transform ${newDiscussionWeb ? 'translate-x-6' : 'translate-x-1'}`} data-id="element-1998" />
                          </button>
                        </div>
                        <div className="flex items-center gap-2" data-id="element-1999">
                          <span className="text-xs font-medium text-gray-500 w-8" data-id="element-2000">
                            Email
                          </span>
                          <button onClick={() => setNewDiscussionEmail(!newDiscussionEmail)} className={`relative inline-flex h-6 w-11 items-center rounded-full transition-colors ${newDiscussionEmail ? 'bg-[#007558]' : 'bg-gray-300'}`} data-id="element-2001">
                            <span className={`inline-block h-4 w-4 transform rounded-full bg-white transition-transform ${newDiscussionEmail ? 'translate-x-6' : 'translate-x-1'}`} data-id="element-2002" />
                          </button>
                        </div>
                        <select value={newDiscussionFrequency} onChange={e => setNewDiscussionFrequency(e.target.value)} className="px-3 py-1.5 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-[#30718D] focus:border-transparent" data-id="element-2003">
                          <option value="daily" data-id="element-2004">Daily</option>
                          <option value="weekly" data-id="element-2005">Weekly</option>
                          <option value="immediately" data-id="element-2006">Immediately</option>
                        </select>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </motion.div>

          {/* Site Preferences Section */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.2
        }} className="bg-white rounded-xl shadow-sm border border-gray-200 overflow-hidden" data-id="element-2007">
            <div className="p-6 border-b border-gray-200" data-id="element-2008">
              <h2 className="text-xl font-bold text-gray-900" data-id="element-2009">
                Site Preferences
              </h2>
            </div>

            <div className="p-6 space-y-6" data-id="element-2010">
              {/* Site Language */}
              <div data-id="element-2011">
                <div className="flex items-center gap-2 mb-2" data-id="element-2012">
                  <label className="text-sm font-semibold text-gray-900" data-id="element-2013">
                    Site language
                  </label>
                  <button className="text-[#30718D] hover:text-[#265a70]" data-id="element-2014">
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" className="text-[#30718D]" data-id="element-2015">
                      <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7" data-id="element-2016"></path>
                      <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z" data-id="element-2017"></path>
                    </svg>
                  </button>
                </div>
                <select value={siteLanguage} onChange={e => setSiteLanguage(e.target.value)} className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#30718D] focus:border-transparent" data-id="element-2018">
                  <option value="English" data-id="element-2019">English</option>
                  <option value="Spanish" data-id="element-2020">Español</option>
                  <option value="French" data-id="element-2021">Français</option>
                  <option value="German" data-id="element-2022">Deutsch</option>
                </select>
                <p className="text-xs text-gray-500 mt-1" data-id="element-2023">
                  The language used throughout this site. This site is currently
                  available in a limited number of languages.
                </p>
              </div>

              {/* Time Zone */}
              <div data-id="element-2024">
                <div className="flex items-center gap-2 mb-2" data-id="element-2025">
                  <label className="text-sm font-semibold text-gray-900" data-id="element-2026">
                    Time zone
                  </label>
                  <button className="text-[#30718D] hover:text-[#265a70]" data-id="element-2027">
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" className="text-[#30718D]" data-id="element-2028">
                      <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7" data-id="element-2029"></path>
                      <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z" data-id="element-2030"></path>
                    </svg>
                  </button>
                </div>
                <button className="text-[#30718D] text-sm font-medium hover:text-[#265a70] mb-2" data-id="element-2031">
                  Set time zone
                </button>
                <p className="text-xs text-gray-500" data-id="element-2032">
                  Select the time zone for displaying course dates. If you do
                  not specify a time zone, course dates, including assignment
                  deadlines, will be displayed in your browser's local time
                  zone.
                </p>
              </div>
            </div>
          </motion.div>

          {/* Linked Accounts Section */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.3
        }} className="bg-white rounded-xl shadow-sm border border-gray-200 overflow-hidden" data-id="element-2033">
            <div className="p-6 border-b border-gray-200" data-id="element-2034">
              <h2 className="text-xl font-bold text-gray-900 mb-2" data-id="element-2035">
                Linked Accounts
              </h2>
              <p className="text-sm text-gray-600" data-id="element-2036">
                You can link your identity accounts to simplify signing in to
                edX.
              </p>
            </div>

            <div className="p-6 space-y-4" data-id="element-2037">
              {/* Apple */}
              <div className="flex items-center justify-between py-3 border-b border-gray-100" data-id="element-2038">
                <div data-id="element-2039">
                  <div className="text-sm font-semibold text-gray-900 mb-1" data-id="element-2040">
                    Apple
                  </div>
                  {linkedAccounts.apple && <div className="text-xs text-gray-500" data-id="element-2041">
                      Linked account: user@icloud.com
                    </div>}
                </div>
                <button onClick={() => setLinkedAccounts({
                ...linkedAccounts,
                apple: !linkedAccounts.apple
              })} className="px-4 py-2 border border-gray-300 rounded-lg text-sm font-medium hover:bg-gray-50 transition-colors" data-id="element-2042">
                  {linkedAccounts.apple ? 'Unlink' : 'Sign in with Apple'}
                </button>
              </div>

              {/* Facebook */}
              <div className="flex items-center justify-between py-3 border-b border-gray-100" data-id="element-2043">
                <div data-id="element-2044">
                  <div className="text-sm font-semibold text-gray-900 mb-1" data-id="element-2045">
                    Facebook
                  </div>
                  {linkedAccounts.facebook && <div className="text-xs text-gray-500" data-id="element-2046">
                      Linked account: user@facebook.com
                    </div>}
                </div>
                <button onClick={() => setLinkedAccounts({
                ...linkedAccounts,
                facebook: !linkedAccounts.facebook
              })} className="px-4 py-2 border border-gray-300 rounded-lg text-sm font-medium hover:bg-gray-50 transition-colors" data-id="element-2047">
                  {linkedAccounts.facebook ? 'Unlink' : 'Sign in with Facebook'}
                </button>
              </div>

              {/* Google */}
              <div className="flex items-center justify-between py-3 border-b border-gray-100" data-id="element-2048">
                <div data-id="element-2049">
                  <div className="flex items-center gap-2 mb-1" data-id="element-2050">
                    <span className="text-sm font-semibold text-gray-900" data-id="element-2051">
                      Google
                    </span>
                    <span className="px-2 py-0.5 bg-[#007558]/10 text-[#007558] text-xs font-medium rounded" data-id="element-2052">
                      Linked
                    </span>
                  </div>
                  {linkedAccounts.google && <div className="text-xs text-gray-500" data-id="element-2053">
                      Linked account: linda.taylor@gmail.com
                    </div>}
                </div>
                <button onClick={() => setLinkedAccounts({
                ...linkedAccounts,
                google: !linkedAccounts.google
              })} className="px-4 py-2 text-[#30718D] hover:bg-[#30718D]/10 rounded-lg text-sm font-medium transition-colors" data-id="element-2054">
                  Unlink Google account
                </button>
              </div>

              {/* Microsoft */}
              <div className="flex items-center justify-between py-3" data-id="element-2055">
                <div data-id="element-2056">
                  <div className="text-sm font-semibold text-gray-900 mb-1" data-id="element-2057">
                    Microsoft
                  </div>
                  {linkedAccounts.microsoft && <div className="text-xs text-gray-500" data-id="element-2058">
                      Linked account: user@outlook.com
                    </div>}
                </div>
                <button onClick={() => setLinkedAccounts({
                ...linkedAccounts,
                microsoft: !linkedAccounts.microsoft
              })} className="px-4 py-2 border border-gray-300 rounded-lg text-sm font-medium hover:bg-gray-50 transition-colors" data-id="element-2059">
                  {linkedAccounts.microsoft ? 'Unlink' : 'Sign in with Microsoft'}
                </button>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </div>;
}